export default __webpack_public_path__ + "static/media/overwhelm3.2e98e362.png";